import { loadSettings } from '../meta/settings';
import { AR } from './ar';

/**
 * Translation (D119). English text is the key: `tr('Campaign')` returns the
 * Arabic when the player picked Arabic, else the English unchanged — so a
 * missing translation degrades to English, never to a blank. `{name}` slots
 * are filled from `vars` after translating.
 */
export type Lang = 'en' | 'ar';

export function lang(): Lang {
  return loadSettings().language;
}

export function tr(en: string, vars?: Readonly<Record<string, string | number>>): string {
  let s = lang() === 'ar' ? AR[en] ?? en : en;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

/** `dir` attribute value for the current language. */
export function dir(): 'rtl' | 'ltr' {
  return lang() === 'ar' ? 'rtl' : 'ltr';
}

/** Every key the Arabic table covers (for tests). */
export function arabicKeys(): string[] {
  return Object.keys(AR);
}
